export default "__VITE_ASSET__DokFbytL__"